import ClientManagementPage from '../../Pages/Client/ClientManagementPage/ClientManagementPage'

export const clientRoutes = [
  {
    path: '/clients/:id',
    name: 'Client Management',
    navBarHeading: 'Client Management',
    rtlName: 'هعذاتسجيل الدخول',
    mini: '',
    rtlMini: '',
    component: ClientManagementPage,
    layout: '/admin',
    redirect: true,
  },
]
export default clientRoutes
